const formateadorCorto = new Intl.DateTimeFormat('es-CR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
});
const formateadorLargo = new Intl.DateTimeFormat('es-CR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
});
function aDate(fecha) {
    if (fecha instanceof Date)
        return Number.isNaN(fecha.getTime()) ? null : fecha;
    // Una fecha sin hora ("2026-10-21") es un día de calendario, no un instante: `new Date` la toma como
    // medianoche UTC y en Costa Rica (UTC-6) se vería como el día anterior. Se arma en hora local.
    const soloFecha = /^(\d{4})-(\d{2})-(\d{2})$/.exec(fecha);
    if (soloFecha)
        return new Date(Number(soloFecha[1]), Number(soloFecha[2]) - 1, Number(soloFecha[3]));
    const d = new Date(fecha);
    return Number.isNaN(d.getTime()) ? null : d;
}
export function formatearFechaCR(fecha, formato = 'corto') {
    const d = aDate(fecha);
    if (!d)
        return '—';
    switch (formato) {
        case 'corto':
            return formateadorCorto.format(d);
        case 'largo':
            return formateadorLargo.format(d);
        case 'iso': {
            const yyyy = d.getFullYear();
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const dd = String(d.getDate()).padStart(2, '0');
            return `${yyyy}-${mm}-${dd}`;
        }
    }
}
//# sourceMappingURL=formatearFecha.js.map